import { OnboardingModel } from "../../constant/amlConstant";

export type kycReferenceType =
  | "OCCUPATION"
  | "INDUSTRY"
  | "SALARY"
  | "BUSINESS"
  | "REASON"
  | "SRCOFFUNDS"
  | "ROLETYPE";

export type kycReferenceItem = {
  code: string;
  description: string;
  type: kycReferenceType;
  removed: boolean;
  extra: {
    dateLabel: string;
    text1Label: string;
    text2Label: string;
    valueLabel: string;
  }
}

export function kycReferenceItemTransformer(row: any): kycReferenceItem {
  return {
    code: row.itemCode,
    description: row.itemDescription,
    type: row.itemType,
    removed: row.removedFlag === "Y",
    extra: {
      dateLabel: row.addInfoDateHead,
      text1Label: row.addInfoText1Head,
      text2Label: row.addInfoText2Head,
      valueLabel: row.addvalueHead
    }
  };
}

export type InvestorKycDetail = {
  personId: string;
  categoryCode: string;
  categoryCodeDescription: string;
  countryOfIncorporation: string;
  dateOfIncorporation: string;
  businessChannelCode: string;
  industryCode: string;
  industryText: string;
  occupationCode: string;
  occupationText: string;
  reasonForInvestCode: string;
  salaryRangeCode: string;
  onboardingModel: (typeof OnboardingModel)[keyof typeof OnboardingModel];
  subTypeCode: string;
  subTypeCodeDescription: string;
  kycStatus: string;
}

export function investorKycDetailTransformer(data: any): InvestorKycDetail {
  return {
    personId: data.personId,
    categoryCode: data.categoryCode,
    categoryCodeDescription: data.categoryCodeDesc,
    countryOfIncorporation: data.countryOfIncorporation,
    dateOfIncorporation: data.dateOfIncorporation,
    businessChannelCode: data.businessChannelCode,
    industryCode: data.industryCode,
    industryText: data.industryText,
    occupationCode: data.occupationCode,
    occupationText: data.occupationText,
    reasonForInvestCode: data.reasonForInvestCode,
    salaryRangeCode: data.salaryRangeCode,
    onboardingModel: data.onboardingModel,
    subTypeCode: data.subTypeCode,
    subTypeCodeDescription: data.subTypeCodeDesc,
    kycStatus: data.kycStatus
  };
}
